<div class="box-container" style="margin: 20px;">
    <div class="box-header">
        <span>{{ 'terms_and_conditions.terms_and_conditions_box_header' | translate }}</span>
    </div>
    <div class="box-item">
        <div [innerHTML]="termsHtml"></div>
    </div>
</div>
